import { Pagination, PaginationItem } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import { styled } from 'styled-components';
import { useSelector } from 'react-redux';

import * as store from '../../../../reducers/store';

import { ReactComponent as ChevronRight } from '../../../../assets/chevron-right.svg';
import { ReactComponent as ChevronLeft } from '../../../../assets/chevron-left.svg';

interface Props {
  currentPage: number;
  onPageClick: (pageNumber: number) => void;
  totalPages?: number;
}

const PaginationControls: React.FC<Props> = ({
  currentPage,
  onPageClick,
  totalPages,
}) => {
  const primaryHexColor: string | undefined = useSelector(
    (store: store.All) => store.theme?.primaryHexColor,
  );
  if (!totalPages || totalPages === 1) {
    return null;
  }

  return (
    <RowWithBorder className="border-top py-4 mt-auto mx-3 mx-sm-0">
      <Col className="ps-0">
        <StyledPagination
          count={totalPages}
          page={currentPage}
          onChange={(_, page) => onPageClick(page)}
          siblingCount={0}
          $primaryBrandColor={primaryHexColor}
          renderItem={(item) => (
            <PaginationItem
              slots={{ previous: ChevronLeft, next: ChevronRight }}
              {...item}
            />
          )}
        />
      </Col>
      <Col xs="auto" className="pe-0 pt-2">
        {currentPage} of {totalPages}
      </Col>
    </RowWithBorder>
  );
};

export default PaginationControls;

const RowWithBorder = styled(Row)`
  border-color: var(--color-border-default-light) !important;
`;

const StyledPagination = styled(Pagination).attrs<{
  $primaryBrandColor?: string;
}>((props) => ({
  $primaryBrandColor: props.$primaryBrandColor || 'var(--color-brand-primary)',
}))`
  .Mui-selected {
    background-color: ${(props) => props.$primaryBrandColor};
    color: white;

    &:hover {
      color: var(--color-content-default);
    }
  }

  .MuiPaginationItem-previousNext {
    &:not(.Mui-disabled) {
      color: ${(props) => props.$primaryBrandColor};
      svg path {
        stroke: ${(props) => props.$primaryBrandColor};
      }
    }
  }
`;
